export default __webpack_public_path__ + "static/media/ChatGPT Image 19 de ago. de 2026, 13_53_02.e38acb7d.png";